import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

import { LoadingController } from 'ionic-angular';
import { LoginPage } from '../login/login';

import { ValidatorProvider } from '../../providers/validator/validator';
import { AlertProvider } from '../../providers/alert/alert';
import { AuthProvider } from '../../providers/auth/auth';
import { NetworkMonitorProvider } from '../../providers/network-monitor/network-monitor';
import { NewRegistrationProvider } from '../../providers/new-registration/new-registration';

import { NewRegistration } from '../../models/newregistration';

/**
 * Generated class for the NewRegistrationExistsPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-new-registration-exists',
  templateUrl: 'new-registration-exists.html',
})
export class NewRegistrationExistsPage {

  public email: string;
  public emails: string[];

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private alertProvider: AlertProvider,
    private loadingCtrl: LoadingController,
    private authProvider: AuthProvider,
    private validatorProvider: ValidatorProvider,
    private newRegistrationProvider: NewRegistrationProvider,
    private networkMonitorProvider: NetworkMonitorProvider,
  ) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad NewRegistrationExistsPage');
    this.emails = this.navParams.get('emails');

    if ((this.emails) && (this.emails.length > 0)) {
      this.email = this.emails[0];
    }
  }

  onBack() {
    this.navCtrl.pop({
      animation: 'ios-transition'
    });
  }

  doRecoverPassword() {
    if (this.validatorProvider.isEmpty(this.email)) {
      this.alertProvider.doAlert('Forneça um e-mail.', 'Atenção');
    } else {
      let that = this;
      this.alertProvider.doConfirm('Você deseja recuperar a senha?', () => {
        let loader = that.loadingCtrl.create({
          content: 'Enviando pedido...',
          duration: 3000
        });
        loader.present();

        if (!that.networkMonitorProvider.isOnline()) {
          that.alertProvider.doAlert('É necessário estar conectado na Internet para recupear a senha.', 'Atenção');
        } else {
          that.authProvider.recoverPassword({
            email: that.email
          }).subscribe((data: any) => {
            if ((data) && (data.reseted)) {
              that.newRegistrationProvider.destroy().subscribe(() => {
                that.alertProvider.doAlert('Acabamos de lhe enviar um e-mail com uma nova senha gerada.', 'Veja seu e-mail', () => {
                  that.navCtrl.setRoot(LoginPage);
                  that.navCtrl.popToRoot();
                });
              }, (error: any) => {
                console.log(error);
                that.alertProvider.doAlert('Acabamos de lhe enviar um e-mail com uma nova senha gerada.', 'Veja seu e-mail', () => {
                  that.navCtrl.setRoot(LoginPage);
                  that.navCtrl.popToRoot();
                });
              });
            } else {
              loader.dismiss();
              that.alertProvider.doAlert('Verique se o e-mail fornecido está correto.', 'Atenção');
            }
          }, (error: any) => {
            console.log(error);
            loader.dismiss();
            that.alertProvider.doAlert('Verique se o e-mail fornecido está correto.', 'Atenção');
          });
        }
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/new-registration-exists/new-registration-exists.ts